import { render } from "./InventoryCoveragePage.vue?vue&type=template&id=e60239ba"
import script from "./InventoryCoveragePage.vue?vue&type=script&lang=js"
export * from "./InventoryCoveragePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__